module.exports = __webpack_public_path__ + "img/top-bg-hen.304cdbeb.png";